// extracted by mini-css-extract-plugin
module.exports = {"notification":"_10yT4OfcKrBqLil6-GYQcl","success":"_32fpTulI1s_xCMPVs7J6G7","error":"_3b7l7d7d1y0kY9eb7SE-Zl","button":"_1pmdb0AkOAYHIlocxiWEz3"};